export default class BlockVideo {
	constructor(container) {
		this.container = container;
		this.video = container.querySelector('video');
		this.playBtn = container.querySelector('.video-play-btn');
		if (!this.video || !this.playBtn) return;

		this.playBtn.addEventListener('click', (e) => this.handlePlayClick(e));
		this.video.addEventListener('play', () => this.playBtn.classList.add('playing'));
		this.video.addEventListener('pause', () => this.playBtn.classList.remove('playing'));
		this.video.addEventListener('ended', () => this.playBtn.classList.remove('playing'));
	}

	handlePlayClick(e) {
		e.preventDefault();
		this.video.setAttribute('controls', '');
		this.video.play();
	}
}
